// @flow

import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';
import apiService from '../api-service';

/**
 * Get GA4 OAuth information
 */
export const getGA4OAuthInformation = async i18n => {
  try {
    const { response, status } = await apiService.fetchApi(
      'admin-v3.third-party-integration.get-ga4-oauth-info',
      {}
    );

    if (status !== 200 && status !== 201) {
      showSABToast(
        i18n.translate('AdminHTML.GoogleAnalytics4.Actions.getInformationFailure'),
        true
      );
      return { response, type: 'error' };
    }

    return { response, type: 'success' };
  } catch (error) {
    console.error('Error fetching GA4 OAuth information:', error);
    return { type: 'error', response: null };
  }
};

/**
 * Get GA4 OAuth authorization URL
 */
export const getGA4OAuthUrl = async (redirectURI, i18n) => {
  try {
    const { response, status } = await apiService.fetchApi(
      'admin-v3.third-party-integration.get-ga4-oauth-url',
      {
        queries: { redirectURI }
      }
    );

    if (status !== 200 && status !== 201) {
      showSABToast(
        i18n.translate('AdminHTML.GoogleAnalytics4.Actions.generateIntegrationLinkError'),
        true
      );
      return { type: 'error', response };
    }

    return { type: 'success', response };
  } catch (error) {
    showSABToast(
      i18n.translate('AdminHTML.GoogleAnalytics4.Actions.generateIntegrationLinkError'),
      true
    );
    return { type: 'error', response: null };
  }
};

/**
 * GA4 OAuth callback - exchange code for tokens
 */
export const ga4OAuthCallback = async (code, state, redirectURI, i18n) => {
  try {
    const { response, status } = await apiService.fetchApi(
      'admin-v3.third-party-integration.ga4-oauth-callback',
      {
        method: 'POST',
        body: { code, state, redirectURI }
      }
    );

    if (status !== 200 && status !== 201) {
      if (i18n) {
        showSABToast(
          i18n.translate('AdminHTML.GoogleAnalytics4.Actions.callbackError'),
          true
        );
      }
      return { type: 'error', response };
    }

    return { type: 'success', response };
  } catch (error) {
    console.error('Error in GA4 OAuth callback:', error);
    return { type: 'error', response: null };
  }
};

/**
 * Disconnect GA4 OAuth
 */
export const disconnectGA4 = async i18n => {
  try {
    const { response, status } = await apiService.fetchApi(
      'admin-v3.third-party-integration.disconnect-ga4',
      {
        method: 'POST'
      }
    );

    if (status !== 200 && status !== 201) {
      showSABToast(
        i18n.translate('AdminHTML.GoogleAnalytics4.Actions.disconnectIntegrationError'),
        true
      );
      return { type: 'error', response };
    }

    showSABToast(
      i18n.translate('AdminHTML.GoogleAnalytics4.Actions.disconnectIntegrationSuccess'),
      false
    );
    return { type: 'success', response };
  } catch (error) {
    showSABToast(
      i18n.translate('AdminHTML.GoogleAnalytics4.Actions.disconnectIntegrationError'),
      true
    );
    return { type: 'error', response: null };
  }
};

/**
 * Switch GA4 property
 */
export const switchGA4Property = async (propertyId, i18n) => {
  try {
    const { response, status } = await apiService.fetchApi(
      'admin-v3.third-party-integration.ga4-switch-property',
      {
        method: 'POST',
        body: { propertyId }
      }
    );

    if (status !== 200 && status !== 201) {
      showSABToast(
        i18n.translate('AdminHTML.GoogleAnalytics4.Actions.switchPropertyError'),
        true
      );
      return { type: 'error', response };
    }

    showSABToast(
      i18n.translate('AdminHTML.GoogleAnalytics4.Actions.switchPropertySuccess'),
      false
    );
    return { type: 'success', response };
  } catch (error) {
    showSABToast(
      i18n.translate('AdminHTML.GoogleAnalytics4.Actions.switchPropertyError'),
      true
    );
    return { type: 'error', response: null };
  }
};
